import React, { useState,useEffect } from "react";
import Slider from 'react-slick';
import { toast } from 'react-toastify';
import CssCodeEditor from "../../../components/CssCodeEditor";
import JsCodeEditor from "../../../components/JsCodeEditor";
import ColorPicker from "../../../components/ColorPicker";

const AppearanceTab = ({updateCountdownTimerTabData,countdownTimerTabData}) => {
    const [activeAppearanceElementsTab, setActiveAppearanceElementsTab] = useState("main");
    const [timerSize, setTimerSize] = useState(countdownTimerTabData.appearance_timer_size);
    const [buttonSize, setButtonSize] = useState(countdownTimerTabData.appearance_button_size);
    const [styleTabCustomCss, setStyleTabCustomCss] = useState(countdownTimerTabData.appearance_custom_css);
    const [jsTabCustomJs, setJsTabCustomJs] = useState(countdownTimerTabData.appearance_custom_js);
    const [timerColor, setTimerColor] = useState(countdownTimerTabData.appearance_colors_timer_color);
    const [timerTextColor, setTimerTextColor] = useState(countdownTimerTabData.appearance_colors_timer_text_color);
    const [labelColor, setLabelColor] = useState(countdownTimerTabData.appearance_colors_labels_color);
    const [messageColor, setMessageColor] = useState(countdownTimerTabData.appearance_colors_message_color);
    const [buttonColor, setButtonColor] = useState(countdownTimerTabData.appearance_colors_button_color);
    const [backgroundColor, setBackgroundColor] = useState(countdownTimerTabData.appearance_colors_background_color);

    //Message Font Size
    const [selectedMessageFontSize, setSelectedMessageFontSize] = useState(countdownTimerTabData.appearance_message_font_size);
    const [showMessageFontSizeDropdown, setShowMessageFontSizeDropdown] = useState(false);
    const layoutMessageFontSizeValues = ["10px", "11px", "12px", "13px", "14px", "15px", "16px", "17px", "18px", "19px", "20px", "30px", "40px", "50px"];
    const toggleMessageFontSizeDropdown = () => {
        setShowMessageFontSizeDropdown(!showMessageFontSizeDropdown);
    };
    const handleMessageFontSizeSelect = (spacing) => {
        setSelectedMessageFontSize(spacing);
        setShowMessageFontSizeDropdown(false);
        updateCountdownTimerTabData("appearance_message_font_size", spacing);
    };

    // Handlers Timer Size Change
    const handleTimerSizeChange = (e) => {
        const value = e.target.value;
        setTimerSize(value);
        updateCountdownTimerTabData("appearance_timer_size", value); 
    };

    // Handlers Button Size Change
    const handleButtonSizeChange = (e) => {
        const value = e.target.value;
        setButtonSize(value);
        updateCountdownTimerTabData("appearance_button_size", value); 
    };
    
    // Handlers Custom CSS Change
    const handleCustomcssCodeChange = (code) => {
        setStyleTabCustomCss(code);
        updateCountdownTimerTabData("appearance_custom_css", code);
    };

    //Inject CSS into the page whenever it changes
    useEffect(() => {
        let styleTag = document.getElementById("custom-style");

        if (!styleTag) {
            styleTag = document.createElement("style");
            styleTag.id = "custom-style";
            document.head.appendChild(styleTag);
        }

        styleTag.innerHTML = styleTabCustomCss || "";
    }, [styleTabCustomCss]);

    // Handlers Custom Js Change
    const handleCustomJsCodeChange = (code) => {
        setJsTabCustomJs(code);
        updateCountdownTimerTabData("appearance_custom_js", code);
    }; 

    // Function to run the JS code when Validate is clicked
    const handleValidateClick = () => { 
        const existingScript = document.getElementById("custom-js");
        if (existingScript) {
            existingScript.remove();
        }
    
        if (jsTabCustomJs && jsTabCustomJs.trim() !== "") {
            const script = document.createElement("script");
            script.id = "custom-js";
            script.type = "text/javascript";
            script.innerHTML = jsTabCustomJs;
    
            document.body.appendChild(script);
    
            toast.success("Custom JS applied successfully");
        } else {
            toast.error("No JS code to apply");
        }
    };

    // Handlers Timer Color Change
    const handleTimerColorChange = (color) => {
        setTimerColor(color.hex);
        updateCountdownTimerTabData("appearance_colors_timer_color", color.hex);
    };

    // Handlers Timer Text Color Change
    const handleTimerTextColorChange = (color) => {
        setTimerTextColor(color.hex);
        updateCountdownTimerTabData("appearance_colors_timer_text_color", color.hex);
    };

    // Handlers Label Color Change
    const handleLabelColorChange = (color) => {
        setLabelColor(color.hex);
        updateCountdownTimerTabData("appearance_colors_labels_color", color.hex);
    };

    // Handlers Message Color Change
    const handleMessageColorChange = (color) => {
        setMessageColor(color.hex);
        updateCountdownTimerTabData("appearance_colors_message_color", color.hex);
    };

    // Handlers Button Color Change
    const handleButtonColorChange = (color) => {
        setButtonColor(color.hex);
        updateCountdownTimerTabData("appearance_colors_button_color", color.hex);
    };
    // Handlers Background Color Change
    const handleBackgroundColorChange = (color) => {
        setBackgroundColor(color.hex);
        updateCountdownTimerTabData("appearance_colors_background_color", color.hex);
    };

    const headerReviewSliderImages = [
        `${process.env.PUBLIC_URL}/countdown-timer/templates/slider-1.png`,
        `${process.env.PUBLIC_URL}/countdown-timer/templates/slider-1.png`,
        /*`${process.env.PUBLIC_URL}/countdown-timer/templates/slider-2.png`,
        `${process.env.PUBLIC_URL}/countdown-timer/templates/slider-3.png`,
        `${process.env.PUBLIC_URL}/countdown-timer/templates/slider-4.png`,
        `${process.env.PUBLIC_URL}/countdown-timer/templates/slider-5.png`,*/
    ];

    /*const holidayThemeImage = [
        `${process.env.PUBLIC_URL}/countdown-timer/templates/slider-6.webp`,
        `${process.env.PUBLIC_URL}/countdown-timer/templates/slider-7.webp`,
        `${process.env.PUBLIC_URL}/countdown-timer/templates/slider-8.webp`,
        `${process.env.PUBLIC_URL}/countdown-timer/templates/slider-9.png`,
        `${process.env.PUBLIC_URL}/countdown-timer/templates/slider-10.webp`,
        `${process.env.PUBLIC_URL}/countdown-timer/templates/slider-11.webp`,
        `${process.env.PUBLIC_URL}/countdown-timer/templates/slider-12.webp`,
        `${process.env.PUBLIC_URL}/countdown-timer/templates/slider-13.png`,
    ];*/

    const sliderSettings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        autoplay: false,
        autoplaySpeed: 2000,
    };

    /*const holidaySliderSettings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        autoplay: false,
        autoplaySpeed: 2000,
    };*/
    return (
        <div className="countdown-timer-side-baar-appearance-tab">
            {activeAppearanceElementsTab === "main" && (
                <>
                    <span>Appearance</span>
                    <div className="side-baar-box-header">
                        <div className="box-header-row">
                            <span>Style</span>
                            <div className="slider-review slider-review-one">
                                <Slider {...sliderSettings}>
                                    {headerReviewSliderImages.map((image, index) => (
                                        <div key={index}>
                                            <img src={image} alt={`slider-image-${index}`} className="slider-image" />
                                        </div>
                                    ))}
                                </Slider>
                            </div>
                        </div>
                        {/*<div className="box-header-row">
                            <span>Holiday Theme</span>
                            <div className="slider-review slider-review-one">
                                <Slider {...holidaySliderSettings}>
                                    {holidayThemeImage.map((image, index) => (
                                        <div key={index}>
                                            <img src={image} alt={`slider-image-${index}`} className="slider-image" />
                                        </div>
                                    ))}
                                </Slider>
                            </div>
                        </div>*/}
                    </div>
                    <div className="customize-elements-list">
                        <ul>
                            <li>
                                <button onClick={() => setActiveAppearanceElementsTab("colors")}>Colors <i className="fa fa-angle-right" aria-hidden="true"></i></button>
                            </li>
                            <li>
                                <button onClick={() => setActiveAppearanceElementsTab("sizes_fonts")}>Sizes & Fonts <i className="fa fa-angle-right" aria-hidden="true"></i></button>
                            </li>
                            <li>
                                <button onClick={() => setActiveAppearanceElementsTab("animation")}>Animation <i className="fa fa-angle-right" aria-hidden="true"></i></button>
                            </li>
                        </ul>
                    </div>
                    <div className="customize-elements-list">
                        <ul>
                            <li>
                                <button onClick={() => setActiveAppearanceElementsTab("custom_css")}>Custom CSS <i className="fa fa-angle-right" aria-hidden="true"></i></button>
                            </li>
                            <li>
                                <button onClick={() => setActiveAppearanceElementsTab("custom_js")}>Custom JS <i className="fa fa-angle-right" aria-hidden="true"></i></button>
                            </li>
                        </ul>
                    </div>
                </>
            )}

            {activeAppearanceElementsTab === "colors" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveAppearanceElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button>Colors</span>
                        <div className="side-baar-box-header">
                            <div className="box-header-row">
                                <span>Timer Color</span>
                                <div className="color-pikr-box">
                                    <ColorPicker color={timerColor} setColor={setTimerColor}  onChangeComplete={handleTimerColorChange}/>
                                </div>
                            </div>
                            <div className="box-header-row">
                                <span>Timer Text Color</span>
                                <div className="color-pikr-box">
                                    <ColorPicker color={timerTextColor} setColor={setTimerTextColor}  onChangeComplete={handleTimerTextColorChange}/>
                                </div>
                            </div>
                            <div className="box-header-row">
                                <span>Labels Color</span>
                                <div className="color-pikr-box">
                                    <ColorPicker color={labelColor} setColor={setLabelColor} onChangeComplete={handleLabelColorChange}/>
                                </div>
                            </div>
                            <div className="box-header-row">
                                <span>Message Color</span>
                                <div className="color-pikr-box">
                                    <ColorPicker color={messageColor} setColor={setMessageColor} onChangeComplete={handleMessageColorChange}/>
                                </div>
                            </div>
                            <div className="box-header-row">
                                <span>Button Color</span>
                                <div className="color-pikr-box">
                                    <ColorPicker color={buttonColor} setColor={setButtonColor} onChangeComplete={handleButtonColorChange}/>
                                </div>
                            </div>
                            <div className="box-header-row">
                                <span>Background Color</span>
                                <div className="color-pikr-box">
                                    <ColorPicker color={backgroundColor} setColor={setBackgroundColor} onChangeComplete={handleBackgroundColorChange}/>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}

            {activeAppearanceElementsTab === "sizes_fonts" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveAppearanceElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button>Sizes & Fonts</span>
                        <div className="side-baar-box-header">
                            <div className="box-header-row">
                                <span>Font</span>
                                <em>Default</em>
                            </div>
                            <div className="box-header-row">
                                <span>Message Font Size</span>
                                <em onClick={toggleMessageFontSizeDropdown}>{selectedMessageFontSize}</em>
                                {showMessageFontSizeDropdown && (
                                    <ul className="dropdown-list">
                                        {layoutMessageFontSizeValues.map((spacing) => (
                                            <li key={spacing} onClick={() => handleMessageFontSizeSelect(spacing)}>
                                                {spacing}
                                            </li>
                                        ))}
                                    </ul>
                                )}
                            </div>
                            <div className="box-header-row">
                                <span>Timer Size</span>
                                <div className="slider-container testimonial-slider-container">
                                    <input type="range" min="2" max="56" value={timerSize} onChange={handleTimerSizeChange}/>
                                    <div className="value">Small</div>
                                    <div className="widht-1920">Large</div>
                                </div>
                            </div>
                            <div className="box-header-row">
                                <span>Button Size</span>
                                <div className="slider-container testimonial-slider-container">
                                    <input type="range" min="2" max="50" value={buttonSize} onChange={handleButtonSizeChange}/>
                                    <div className="value">Small</div>
                                    <div className="widht-1920">Large</div>
                                </div>
                            </div>
                        </div>

                    </div>
                </>
            )}

            {activeAppearanceElementsTab === "animation" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveAppearanceElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button>Animation</span>
                        <div className="side-baar-box-header">
                            <div className="box-header-row">
                                <span>Animation</span>
                                <em>None</em>
                            </div>
                        </div>
                    </div>
                </>
            )}

            {activeAppearanceElementsTab === "custom_css" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveAppearanceElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button> Custom CSS</span>
                        <div className="css-text height-text">
                            <CssCodeEditor code={styleTabCustomCss} setCode={setStyleTabCustomCss} onChangeComplete={handleCustomcssCodeChange}/>
                        </div>
                    </div>
                </>
            )}

            {activeAppearanceElementsTab === "custom_js" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveAppearanceElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button> Custom Js</span>
                        <div className="css-text height-text">
                            <JsCodeEditor code={jsTabCustomJs} setCode={setJsTabCustomJs} onChangeComplete={handleCustomJsCodeChange}/>
                            <div className="save-css-js"><button className="save-css-js" onClick={handleValidateClick}>Validate</button></div>
                        </div>
                    </div>
                </>
            )}
        </div>
    );
};

export default AppearanceTab;